import {Serializer} from "../interfaces/serializer";
import {DataSetMetric, DataSourceMetric, Metric} from '../interfaces/metrics';
import {BehaviorSubject} from "rxjs";

export type MetricComponentObjects = Array<MetricComponentObject>;

export class MetricComponentObject {
  public payload: Serializer<DataSetMetric | DataSourceMetric | Metric>;

  public name$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public slug$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(
    payload: Serializer<DataSetMetric | DataSourceMetric | Metric>
  ) {
    this.update(payload);
  }

  public update(payload: Serializer<DataSetMetric | DataSourceMetric | Metric>): void {
    this.payload = payload;

    this.name$.next(payload.attributes.name);
    this.slug$.next(payload.attributes.slug);
  }
}
